export default __webpack_public_path__ + "assets/cfeb13e48afcb1c514a2a41023d4a133.svg";